<template lang="pug">
  div
    notifications(group="show_complaint" position="top center")
    b-row.justify-content-md-center(v-if="complaint.number")
      ReloadAppDialog(:showDialog="showDialog")
      b-col(md="3")
        b-card.complaint-actions
          h4 Proceder con reclamo
          h6
            small Elige una de las opciones
          actions(:complaint="complaint" ,@sendUpdate="updateActivity")
      b-col(md="9")
        b-btn.btn-back(@click="back")
          icon(name="chevron-left")
          |  Volver a Reclamos
        b-card(:title="`Reclamo #${complaint.number}`")
          b-btn(v-clipboard:copy="public_url" v-clipboard:success="notifyCopy" size="sm" title="Copiar URL pública del reclamo en el portapapeles") Copiar link&nbsp;
            icon(name="copy")
          br
          p.complaint-main-meta Registrado por {{ complaint.agent_name }}
            br
            | Ingresado el {{ complaint.created_at | formatDate }} - Edad {{ complaintAge }}
          ul.complaint-summary-meta
            li
              span.meta-info-title Estado
              span.complaint-meta-value.complaint-status-wrapper(:class="statusClassName(complaint)") {{ complaint.aasm_state | formatStatus }}
              span.edit-icon-container(@click="slideEditAttribute" v-if="$isAllowed('viewAdmin') || $isAllowed('viewERR')")
                icon(name="chevron-down")
              div.edit-attribute(v-if="$isAllowed('viewAdmin') || $isAllowed('viewERR')" title="Editar")
                selectize(v-model.trim="complaint.aasm_state")
                  option(v-for="(status, index) in statuses" ,:value="index") {{ status.description }}
                b-btn(title="Guardar cambio" variant="outline-success" ,@click="updateComplaintAttributes")
                  icon(name="save")
            li
              span.meta-info-title Categoría
              div
                span.complaint-meta-value {{ complaint.complaint_category.name }}
                span.edit-icon-container(@click="slideEditAttribute" v-if="$isAllowed('viewAdmin') || $isAllowed('viewERR')")
                  icon(name="chevron-down")
                div.edit-attribute(v-if="$isAllowed('viewAdmin') || $isAllowed('viewERR')" title="Editar")
                  selectize(v-model.trim="complaint.category")
                    option(v-for="(category, index) in categories" ,:value="index") {{ category.description }}
                  b-btn(title="Guardar cambio" variant="outline-success" ,@click="updateComplaintAttributes")
                    icon(name="save")
            li
              span.meta-info-title Exigencia
              span.complaint-meta-value {{ complaint.comment }}
              span.edit-icon-container(@click="slideEditAttribute" v-if="$isAllowed('viewAdmin') || $isAllowed('viewERR')")
                icon(name="chevron-down")
              div.edit-attribute(v-if="$isAllowed('viewAdmin') || $isAllowed('viewERR')" title="Editar")
                b-input(v-model="complaint.comment")
                b-btn(title="Guardar cambio" variant="outline-success" ,@click="updateComplaintAttributes")
                  icon(name="save")
          p.related-zendesk(v-if="complaint.zendesk.length > 0") Comunicación con el cliente&nbsp;
            | (Zendesk&nbsp;
            span(v-for="(zendesk_id, index) in complaint.zendesk")
              a.zendesk-ticket-link(:href="`https://recorrido.zendesk.com/agent/tickets/${zendesk_id}`" target="_blank" title="Ver ticket en Zendesk") {{ zendesk_id }}
              span(v-if="index < complaint.zendesk.length - 1") ,&nbsp;
            |&nbsp;
            icon(name="external-link")
            |)
          audio(controls="controls" v-if="this.complaint.additional_infos && this.complaint.additional_infos.length > 0 && this.complaint.source === 'voice'")
            source(:src="this.complaint.additional_infos[0].url" type="audio/mpeg")
          blockquote.card-text(v-if="complaint.description")
            pre {{ complaint.description }}
        hr
        b-card.tabs-container(no-body)
          b-tabs(ref="tabs" card)
            b-tab(title="Pasajes afectados" active)
              h5(v-if="complaint.ticket_info && complaint.ticket_info.tickets.length > 0") Información de los pasajes afectados
              table.table(v-if="complaint.ticket_info && complaint.ticket_info.tickets.length > 0")
                tr(v-show="complaint.ticket_info.booking_number")
                  td Número de Compra
                  td {{ complaint.ticket_info.booking_number }}
                tr(v-show="complaint.ticket_info.tickets.length > 0")
                  td Pasajes afectados
                  td {{ complaint.ticket_info.tickets.join(', ') }}
                tr
                  td Empresa(s)
                  td {{ complaint.ticket_info.bus_operators | formatOperator }}
                tr
                  td Fecha de salida (Ida)
                  td {{ complaint.ticket_info.departure | formatDate }}
                tr
                  td Hora de salida (Ida)
                  td {{ complaint.ticket_info.departure | formatHour }}
                tr(v-if="complaint.ticket_info.arrival")
                  td Fecha de salida (Vuelta)
                  td {{ complaint.ticket_info.arrival | formatDate }}
                tr(v-if="complaint.ticket_info.arrival")
                  td Hora de salida (Vuelta)
                  td {{ complaint.ticket_info.arrival | formatHour }}
                tr
                  td Método de pago
                  td {{ complaint.ticket_info.payment_method }}
                tr
                  td Método de reembolso
                  td {{ refundMethod }}
                tr
                  td Precio
                  td {{ complaint.ticket_info.price }} {{ complaint.ticket_info.sold_currency }}
                tr
                  td Precio IBC
                  td {{ complaint.ticket_info.price_ibc }}
                tr
                  td Comprador
                  td {{ complaint.ticket_info.fullname }}
                tr
                  td Email comprador
                  td {{ complaint.ticket_info.email }}
            b-tab(title="Adjuntos")
              vue-dropzone#dropzone(ref='attachmentsDrop', :options='dropzoneOptions', @vdropzone-success="fetchComplaint")
              b-list-group(v-if="complaint.additional_infos")
                hr
                h3 Archivos adjuntos
                div.list-group-item.list-group-item-action(v-for="info in complaint.additional_infos" v-if="info.url !== null")
                  span(v-if="info.format === 'mp3'")
                    audio(controls="controls")
                      source(:src="info.url" type="audio/mpeg")
                  div(v-else)
                    div.attachment_content(v-if="['png', 'jpg', 'jpeg', 'gif'].includes(info.format)")
                      b-btn(@click="openFileModal(info._id.$oid)")
                        icon(name="image")
                        |  {{ `${info.name}.${info.format}` }}
                      b-modal.image-modal(:ref="`imageModal-${info._id.$oid}`")
                        img(:src="signedLink")
                        div(slot="modal-cancel") Cerrar
                        div(slot="modal-ok")
                          a(:href="signedLink" target="_blank") Abrir en pestaña externa
                    div.attachment_content(v-else-if="info.format === 'pdf'")
                      a(@click="openFileTab(info._id.$oid)")
                        icon(name="paperclip")
                        |  {{ `${info.name}.${info.format}` }}&nbsp;&nbsp;
                        icon(name="external-link")
                    span(v-else)
                      a(@click="dowloadFile(info._id.$oid)")
                        icon(name="paperclip")
                        |  {{ `${info.name}.${info.format}` }}&nbsp;&nbsp;
                        icon(name="download")
                    div.attachment_actions(v-if="$isAllowed('deleteAttachment')")
                      b-btn(@click="deleteAttachment(info._id.$oid)" size="xs")
                        icon(name="trash")
                        |  Eliminar
            b-tab(title="Solicitudes de información")
              input#requestFile(type="file" ,@change="uploadFile()" hidden)
              b-form(@submit.prevent="requestInfo")
                b-input-group
                  b-form-input.form-control(v-model.trim="info_request" placeholder="Información a solicitar")
                  b-input-group-button(slot="right")
                    b-btn(type="submit" variant="primary") Solicitar
              b-list-group(v-if="requests")
                hr
                b-list-group-item(v-for="r in requests" ,:key="r.name")
                  icon(name="inbox")
                  span(v-html="r.request")
                  button.float-right(v-if="r.url === null" variant="primary" ,@click="addFile(r._id.$oid)")
                    icon(name="paperclip")
                    | Adjuntar
                  a.float-right(v-if="r.url !== null" ,:href="r.url") {{ `${r.name}.${r.format}` }}
            b-tab(v-if="('reimbursement' in complaint) && complaint.reimbursement.compensation_type === 'm' && allowed_payment_methods.includes(complaint.ticket_info.payment_method) || complaint.category === -1", title="Datos de reembolso")
              div(v-if="Object.keys(bank_info).length === 0")
                .bank-btns
                  div(style="float: right")
                    b-row.mb-1(v-if="canAddBankData()")
                      b-col
                        button.btn.btn-success(v-b-modal="'editBankData'") Ingresar datos bancarios
                    b-row(v-if="canUpdateRefundMethod()")
                      b-col
                        button.btn.btn-success(v-b-modal="'editRefundMethod'") Cambiar método de reembolso
                table.table.table-bordered.table-responsive
                  tr
                    th Método de reembolso
                    td.selectable(
                      v-clipboard:copy="refundMethod"
                      v-clipboard:success="dataCopied") {{ refundMethod }}
                  tr(v-if="complaint.reimbursement && complaint.reimbursement.paypal_email")
                    th Correo PayPal
                    td.selectable(
                      v-clipboard:copy="complaint.reimbursement.paypal_email"
                      v-clipboard:success="dataCopied") {{ complaint.reimbursement.paypal_email }}
                  template(v-if="'reimbursement' in complaint")
                    tr
                      th Monto devolución
                      td.selectable(
                        v-if="complaint.reimbursement.amount"
                        v-clipboard:copy="complaint.reimbursement.amount"
                        v-clipboard:success="dataCopied") {{ complaint.reimbursement.amount }}
                      td(v-else) No se ha registrado
                    tr(v-if="complaint.reimbursement.paypal_email === null")
                      th Código de TEF
                      td(v-if="complaint.reimbursement.tef_code"
                        v-clipboard:copy="complaint.reimbursement.tef_code"
                        v-clipboard:success="dataCopied") {{ complaint.reimbursement.tef_code }}
                      td(v-else) No se ha registrado
                    tr(v-if="complaint.reimbursement.paypal_email === null")
                      th Fecha de TEF
                      td(v-if="complaint.reimbursement.tef_date")  {{ complaint.reimbursement.tef_date | formatDate }}
                      td(v-else) No se ha registrado
              div(v-else)
                .bank-btns
                  div(style="float: right")
                    b-row.mb-1
                      b-col
                        button.btn.btn-success(v-b-modal="'editBankData'") Editar datos bancarios
                    b-row(v-if="canUpdateRefundMethod()")
                      b-col
                        button.btn.btn-success(v-b-modal="'editRefundMethod'") Cambiar método de reembolso
                  button.btn.btn-primary(v-clipboard:copy="copyBankData" v-clipboard:success="notifyCopyBank" size="sm" title="Copiar datos bancarios") Copiar datos
                table.table.table-bordered.table-responsive
                  tbody(v-if="complaint.country === 'CL'")
                    tr
                      th Método de reembolso
                      td.selectable(
                        v-clipboard:copy="refundMethod"
                        v-clipboard:success="dataCopied") {{ refundMethod }}
                    tr
                      th Nombre
                      td.selectable(
                        v-clipboard:copy="bank_info.name"
                        v-clipboard:success="dataCopied") {{ bank_info.name }}
                    tr
                      th RUT
                      td.selectable(
                        v-clipboard:copy="bank_info.rut"
                        v-clipboard:success="dataCopied") {{ bank_info.rut | rutFilter }}
                    template(v-if="'reimbursement' in complaint")
                      tr(v-if="complaint.reimbursement.paypal_email === null")
                        th Correo comprador
                        td.selectable(
                          v-clipboard:copy="complaint.ticket_info.email"
                          v-clipboard:success="dataCopied") {{ complaint.ticket_info.email  }}
                      tr(v-if="complaint.reimbursement.paypal_email === null")
                        th Banco
                        td.selectable(
                          v-clipboard:copy="bank_info.bank"
                          v-clipboard:success="dataCopied") {{ bank_info.bank }}
                      tr(v-if="complaint.reimbursement.paypal_email === null")
                        th Tipo de Cuenta
                        td.selectable(v-if="bank_info.account_type !== null"
                          v-clipboard:copy="accounts[bank_info.account_type].description"
                          v-clipboard:success="dataCopied") {{ accounts[bank_info.account_type].description }}
                        td(v-else) No se indicó tipo de cuenta
                      tr(v-if="complaint.reimbursement.paypal_email === null")
                        th Número de Cuenta
                        td.selectable(
                          v-clipboard:copy="bank_info.account_number"
                          v-clipboard:success="dataCopied") {{ bank_info.account_number }}
                      tr
                        th Monto devolución
                        td.selectable(
                          v-if="complaint.reimbursement.amount"
                          v-clipboard:copy="complaint.reimbursement.amount"
                          v-clipboard:success="dataCopied") {{ complaint.reimbursement.amount }}
                        td(v-else) No se ha registrado
                      tr(v-if="complaint.reimbursement.paypal_email === null")
                        th Código de TEF
                        td(v-if="complaint.reimbursement.tef_code"
                          v-clipboard:copy="complaint.reimbursement.tef_code"
                          v-clipboard:success="dataCopied") {{ complaint.reimbursement.tef_code }}
                        td(v-else) No se ha registrado
                      tr(v-if="complaint.reimbursement.paypal_email === null")
                        th Fecha de TEF
                        td(v-if="complaint.reimbursement.tef_date")  {{ complaint.reimbursement.tef_date | formatDate }}
                        td(v-else) No se ha registrado
                  tbody(v-if="complaint.country === 'PE'")
                    tr
                      th Método de reembolso
                      td.selectable(
                        v-clipboard:copy="refundMethod"
                        v-clipboard:success="dataCopied") {{ refundMethod }}
                    tr(v-if="complaint.reimbursement.paypal_email")
                      th Correo PayPal
                      td.selectable(
                        v-clipboard:copy="complaint.reimbursement.paypal_email"
                        v-clipboard:success="dataCopied") {{ complaint.reimbursement.paypal_email }}
                    tr
                      th Nombre
                      td.selectable(
                        v-clipboard:copy="bank_info.name"
                        v-clipboard:success="dataCopied") {{ bank_info.name }}
                    tr
                      th Documento
                      td.selectable(
                        v-clipboard:copy="bank_info.document_type"
                        v-clipboard:success="dataCopied") {{ bank_info.document_type }}
                    tr
                      th Número de Documento
                      td.selectable(
                        v-clipboard:copy="bank_info.document_number"
                        v-clipboard:success="dataCopied") {{ bank_info.document_number }}
                    tr
                      th Correo comprador
                      td.selectable(
                        v-clipboard:copy="complaint.ticket_info.email"
                        v-clipboard:success="dataCopied") {{ complaint.ticket_info.email  }}
                    tr
                      th Banco
                      td.selectable(
                        v-clipboard:copy="bank_info.bank"
                        v-clipboard:success="dataCopied") {{ bank_info.bank }}
                    tr
                      th Tipo de Cuenta
                      td.selectable(v-if="bank_info.account_type !== null"
                        v-clipboard:copy="accounts[bank_info.account_type].description"
                        v-clipboard:success="dataCopied") {{ accounts[bank_info.account_type].description }}
                      td(v-else) No se indicó tipo de cuenta
                    tr
                      th Número de Cuenta
                      td.selectable(
                        v-clipboard:copy="bank_info.account_number"
                        v-clipboard:success="dataCopied") {{ bank_info.account_number }}
                    tr
                      th CCI
                      td.selectable(
                        v-clipboard:copy="bank_info.cci"
                        v-clipboard:success="dataCopied") {{ bank_info.cci }}
                    template(v-if="'reimbursement' in complaint")
                      tr
                        th Monto devolución
                        td.selectable(
                          v-if="complaint.reimbursement.amount"
                          v-clipboard:copy="complaint.reimbursement.amount"
                          v-clipboard:success="dataCopied") {{ complaint.reimbursement.amount }}
                        td(v-else) No se ha registrado
                      tr
                        th Código de TEF
                        td(v-if="complaint.reimbursement.tef_code"
                          v-clipboard:copy="complaint.reimbursement.tef_code"
                          v-clipboard:success="dataCopied") {{ complaint.reimbursement.tef_code }}
                        td(v-else) No se ha registrado
                      tr
                        th Fecha de TEF
                        td(v-if="complaint.reimbursement.tef_date")  {{ complaint.reimbursement.tef_date | formatDate }}
                        td(v-else) No se ha registrado
              b-modal#editBankData(ref="bankDataModal" hide-footer=true no-close-on-backdrop=true)
                show-bank-account-form(:complaint="complaint" @fetchComplaint="fetchComplaint")
              b-modal#editRefundMethod(ref="editRefundMethod" hide-footer=true no-close-on-backdrop=true @hide="closeRefundMethodModal()")
                b-form.form-horizontal(@submit.prevent="updateRefundMethod")
                  b-form-group(label="Correo electrónico")
                    b-form-input.form-control(v-model="refund_method.email" v-validate="'required|email'" data-vv-as="correo" name="refund_method[email]" type="email" autocomplete="off")
                    span.has-error(v-show="errors.has('refund_method[email]')") {{ errors.first('refund_method[email]') }}
                  b-form-group(label="Método de reembolso")
                    selectize(v-model="refund_method.code" data-vv-as="método de reembolso" name="refund_method[code]" v-validate="'required'")
                      option(v-for="refund_method in refund_methods" :value="refund_method.code" :key="refund_method.description") {{ refund_method.description }}
                    span.has-error(v-show="errors.has('refund_method[code]')") {{ errors.first('refund_method[code]') }}
                  b-form-group.text-center
                    b-button(type="submit" variant="primary") Actualizar
            b-tab(:title="commentsTitle")
              comments(:complaint="complaint._id.$oid" ref="comments")
            b-tab(title="Historial de acciones")
              last-activity(:complaint="complaint._id.$oid" ref="activity")
            b-tab(v-if="complaint.approved_at !== null && ($isAllowed('viewAdmin') || $isAllowed('viewFDP') || $isAllowed('viewERR'))", title="Editar descuento")
              button.btn.btn-success(style="float: right" v-b-modal="'editComplaintDataModal'")
                icon(name="warning")
                | &nbsp;Editar reclamo
              table.table.table-bordered.table-responsive
                tbody
                  tr
                    th Descuento de la empresa de bus
                    td(v-if="complaint.reimbursement.discount_from_company") Sí
                    td(v-else) No
                  tr(v-if="complaint.reimbursement.discount_from_company")
                    th Porcentaje
                    td {{ complaint.reimbursement.discount_percentage }}%
                  tr(v-if="complaint.reimbursement.discount_from_company")
                    th Monto de descuento empresa de bus
                    td {{ complaint.reimbursement.discount | currency('CLP $', 0, { thousandsSeparator: '.'}) }}
              b-modal#editComplaintDataModal(ref="editComplaintDataModal")
                b-form.form-horizontal(@submit.prevent="updateBusOperatorDiscount")
                  b-form-group(label="Descontar de empresa de bus")
                    b-form-radio-group(:options="[{ text: 'Sí', value: true }, { text: 'No', value: false }]"
                      v-model="complaint.reimbursement.discount_from_company" ,@value="complaint.reimbursement.discount_from_company")
                  b-form-group(label="Descuento de la empresa de bus")
                    input.form-control(v-model.trim="complaint.reimbursement.discount" ,@input="setCompanyDiscount($event)")
                  b-form-group(label="Porcentaje de descuento")
                    input.form-control(v-model.trim="complaint.reimbursement.discount_percentage" ,@input="setCompanyDiscountPercentage($event)")
                div(slot="modal-footer").form-group.text-center
                  b-button(@click="updateBusOperatorDiscount" variant="primary") Actualizar
                  | &nbsp;
                  b-button(@click="closeModal") Cancelar
    icon.loading-section(name="spinner" scale="5" pulse v-else)
</template>

<script>
import store from '@/store';
import actionsPerimeter from '@/perimeters/actionsPerimeter';
import Selectize from 'vue2-selectize';
import constants from '@/constants/Status.constants';
import url from '@/constants/Url.constants';
import kexaApi from '@/services/apiService';
import Actions from '@/components/layout/Actions';
import Comments from '@/components/layout/Comments';
import LastActivity from '@/components/layout/LastActivity';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import { Validator } from 'vee-validate';
import { rutValidator } from 'vue-dni';
import ShowBankAccountForm from '@/components/forms/ShowBankAccountForm';
import dateService from '@/utils/dateService';

export default {
  name: 'show_complaint',
  components: {
    Actions,
    Comments,
    Selectize,
    LastActivity,
    vueDropzone: vue2Dropzone,
    ShowBankAccountForm,
  },
  perimeters: [actionsPerimeter],
  data() {
    return {
      complaint: {},
      bank_info: {},
      dropzoneOptions: {
        url: `${url.API_URL}/complaints/${this.$route.params.complaint_id}/additional_info`,
        dictDefaultMessage: 'Cargar archivos',
        thumbnailWidth: 150,
        maxFilesize: 8,
        headers: { Authorization: `Bearer ${this.$store.getters.token}` },
      },
      dialogOptions: {
        okText: 'Continuar',
        cancelText: 'Cancelar',
      },
      new_status: null,
      statuses: constants.STATUSES,
      categories: [],
      accounts: constants.ACCOUNTS,
      complaint_attachment: null,
      request_id: null,
      info_request: null,
      loader: false,
      max: 16,
      allowed_payment_methods: constants.PAYMENT_METHODS,
      refund_methods: constants.REFUND_METHODS,
      signedLink: '',
      refund_method: {
        email: '',
        code: '',
      },
      showDialog: false,
      intervalId: null,
    };
  },
  computed: {
    commentsTitle() {
      const svgCircle = '<svg aria-hidden="true" data-icon="circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-circle"><path fill="red" d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z" class=""></path></svg>';
      if (this.$store.getters.commentsLength > 0) {
        return `Comentarios ${svgCircle}`;
      }
      return 'Comentarios';
    },
    complaintAge() {
      return dateService.complaintAge(this.complaint.created_at);
    },
    requests() {
      if (this.complaint.additional_infos === undefined) {
        return [];
      }
      return this.complaint.additional_infos.filter(n => n.source === 'internal');
    },
    public_url() {
      let currentUrl = document.location.href;
      currentUrl = currentUrl.replace('complaints', 'status');

      return currentUrl;
    },
    copyBankData() {
      switch (this.complaint.country) {
        case 'PE':
          return `Método de reembolso: ${this.complaint.refund_method}\n` +
                  `Nombre: ${this.bank_info.name}\n` +
                  `Tipo de documento: ${this.bank_info.document_type}\n` +
                  `Número de documento: ${this.bank_info.document_number}\n` +
                  `Correo comprador: ${this.complaint.ticket_info.email}\n` +
                  `Banco: ${this.bank_info.bank}\n` +
                  `Tipo de Cuenta: ${this.accounts[this.bank_info.account_type].description}\n` +
                  `Número de Cuenta: ${this.bank_info.account_number}\n` +
                  `CCI: ${this.bank_info.cci}`;
        default:
          return `Método de reembolso: ${this.complaint.refund_method}\n` +
                  `Nombre: ${this.bank_info.name}\n` +
                  `RUT: ${this.bank_info.rut}\n` +
                  `Correo comprador: ${this.complaint.ticket_info.email}\n` +
                  `Banco: ${this.bank_info.bank}\n` +
                  `Tipo de Cuenta: ${this.accounts[this.bank_info.account_type].description}\n` +
                  `Número de Cuenta: ${this.bank_info.account_number}`;
      }
    },
    refundMethod() {
      switch (this.complaint.refund_method) {
        case 'payroll_bank': return 'Nómina Banco';
        case 'devolution_paypal': return 'Reembolso PayPal';
        case 'payroll_paypal': return 'Nómina PayPal';
        case 'devolution_payu': return 'Reembolso PayU';
        case 'devolution_tbk': return 'Reembolso TBK';
        case 'devolution_oneclick': return 'Reembolso Oneclick';
        case 'devolution_fintoc': return 'Reembolso Fintoc';
        default: return '';
      }
    },
  },
  beforeMount() {
    Validator.extend('rut', rutValidator);
    this.fetchCategories();
    this.fetchComplaint();
    this.refreshReloaAppStatus();
  },
  methods: {
    statusClassName(complaint) {
      const statusClass = this.statuses[complaint.aasm_state] === undefined ? null :
        this.statuses[complaint.aasm_state].initials.toLowerCase();
      return `status-${statusClass}`;
    },
    fetchCategories() {
      kexaApi.get_categories().then((res) => {
        this.categories = res.body.reduce((acc, item) => {
          acc[item.number] = { description: item.name };
          return acc;
        }, {});
      });
    },
    fetchComplaint() {
      kexaApi.get(this.$route.params.complaint_id)
        .then((data) => {
          this.complaint = data.body;
          this.new_status = data.body.status;
          this.bank_info = data.body.bank_account || {};
          if (this.complaint.bank_account === undefined) {
            this.complaint.bank_account = data.body.bank_account || {};
          }
          document.title = `Reclamo #${this.complaint.number} | Kexa`;
          store.commit('selectComplaint', this.complaint);
        });
    },
    slideEditAttribute(e) {
      let currentElement = e.target;
      const activeEditClass = 'active-edit';
      const editVisibleClass = 'edit-visible';

      // Normalize element selection
      if (currentElement.tagName === 'path') {
        currentElement = currentElement.parentElement;
      } else if (currentElement.tagName === 'SPAN') {
        currentElement = currentElement.querySelector('svg');
      }

      // Toggle classes to display respective edit fields
      if (!currentElement.classList.contains(activeEditClass)) {
        currentElement.classList.add(activeEditClass);
        currentElement.parentElement.nextElementSibling.classList.add(editVisibleClass);
      } else {
        currentElement.classList.remove(activeEditClass);
        currentElement.parentElement.nextElementSibling.classList.remove(editVisibleClass);
      }
    },
    setCompanyDiscount(e) {
      this.complaint.reimbursement.discount = e.target.value;
      this.complaint.reimbursement.discount_percentage = (100 *
          (this.complaint.reimbursement.discount / this.complaint.ticket_info.original_price))
        .toFixed(2);
    },
    setCompanyDiscountPercentage(e) {
      this.complaint.reimbursement.discount_percentage = e.target.value;
      this.complaint.reimbursement.discount = ((this.complaint.reimbursement.discount_percentage *
          this.complaint.ticket_info.original_price) / 100).toFixed(2);
    },
    updateBusOperatorDiscount() {
      const $this = this;
      const currentReimbursement = $this.complaint.reimbursement;

      if (currentReimbursement.discount_from_company === false) {
        currentReimbursement.discount_percentage = 0;
        currentReimbursement.discount = 0;
      }

      if (currentReimbursement.discount_from_company === true &&
          (currentReimbursement.discount_percentage === 0 || currentReimbursement.discount === 0)) {
        this.$notify({
          group: 'show_complaint',
          type: 'error',
          title: 'Error',
          text: 'No puedes guardar un descuento de 0',
          duration: 3000,
        });
      } else {
        kexaApi.update($this.$route.params.complaint_id, {
          new_state: '',
          reimbursement: currentReimbursement,
        }).then(() => {
          this.$notify({
            group: 'show_complaint',
            type: 'success',
            title: 'Éxito',
            text: 'Se ha actualizado el descuento del reclamo',
            duration: 3000,
          });
          $this.fetchComplaint();
          $this.$refs.editComplaintDataModal.hide();
        });
      }
    },
    updateComplaintAttributes() {
      const newAasmState = this.complaint.aasm_state;
      const newCategory = this.complaint.category;
      const newComment = this.complaint.comment;

      kexaApi.forceUpdate(this.$route.params.complaint_id, {
        aasm_state: newAasmState,
        category: newCategory,
        comment: newComment,
      }).then(() => {
        this.$notify({
          group: 'show_complaint',
          type: 'success',
          title: 'Éxito',
          text: 'Reclamo actualizado',
          duration: 3000,
        });
        document.querySelectorAll('.edit-icon-container .fa-icon').forEach(c => c.classList.remove('active-edit'));
        document.querySelectorAll('.edit-attribute').forEach(c => c.classList.remove('edit-visible'));
        this.fetchComplaint();
      }).catch((exception) => {
        if (exception.status === 405) {
          this.$notify({
            group: 'show_complaint',
            type: 'error',
            text: 'No es posible actualizar este reclamo, porque ya está siendo procesado por una cancelación. Solo puede ser actualizado a Resuelto',
            duration: 8000,
          });
        } else if (exception.status === 422 && newAasmState === 'approved_reimbursement') {
          this.$notify({
            group: 'show_complaint',
            type: 'error',
            text: 'Debe ingresar un porcentaje a reembolsar al reclamo',
            duration: 8000,
          });
        } else {
          this.$notify({ group: 'show_complaint', title: 'Error', text: 'Error al actualizar el reclamo', type: 'error', duration: 3000 });
        }
      });
    },
    uploadAttachment() {
      const formData = new FormData();
      const $this = this;
      formData.append('request', 'add');
      $this.loader = true;
      if (this.complaint_attachment !== null) {
        formData.append('file', this.complaint_attachment);
        kexaApi.upload_file(this.$route.params.complaint_id, formData).then(() => {
          $this.complaint_attachment = null;
          $this.fetchComplaint();
          $this.loader = false;
        });
      }
    },
    requestInfo() {
      kexaApi.request_info(this.$route.params.complaint_id, {
        request: this.info_request,
      }).then(() => {
        this.info_request = null;
        this.fetchComplaint();
      });
    },
    addFile(id) {
      document.getElementById('requestFile').click();
      this.request_id = id;
    },
    uploadFile() {
      const formData = new FormData();
      formData.append('request_id', this.request_id);
      formData.append('file', document.getElementById('requestFile').files[0]);
      kexaApi.append_file(this.$route.params.complaint_id, formData).then(() => {
        this.fetchComplaint();
      });
    },
    updateActivity() {
      this.$refs.activity.fetchActivities();
    },
    closeModal() {
      this.$refs.editComplaintDataModal.hide();
      this.$refs.bankDataModal.hide();
    },
    notifyCopy() {
      this.$notify({
        group: 'show_complaint',
        type: 'success',
        title: 'Éxito',
        text: 'La URL pública de este reclamo ha sido copiada a tu portapapeles.',
        duration: 3000,
      });
    },
    notifyCopyBank() {
      this.$notify({
        group: 'show_complaint',
        type: 'success',
        title: 'Éxito',
        text: 'Los datos bancarios han sido copiados a tu portapapeles.',
        duration: 3000,
      });
    },
    dataCopied() {
      this.$notify({
        group: 'show_complaint',
        type: 'success',
        title: 'Éxito',
        text: 'Dato copiado al portapapeles.',
        duration: 3000,
      });
    },
    back() {
      this.$router.go(-1);
    },
    deleteAttachment(attachment) {
      const $this = this;
      this.$dialog.confirm('¿Deseas eliminar el archivo adjunto?', this.dialogOptions)
        .then(() => {
          kexaApi.removeAttachment($this.$route.params.complaint_id, attachment).then(() => {
            $this.fetchComplaint();
          });
        }).catch(() => {});
    },
    updateRefundMethod() {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          this.$dialog.confirm({
            title: 'Método de reembolso',
            body: '¿Desea continuar con los cambios?',
          }).then(() => {
            kexaApi.updateRefundMethod(this.$route.params.complaint_id, this.refund_method).then(() => {
              this.$refs.editRefundMethod.hide();
              this.refund_method = { email: '', code: '' };
              this.$validator.reset();
              this.fetchComplaint();
            }).catch((response) => {
              this.$notify({
                group: 'show_complaint',
                type: 'error',
                title: 'Error',
                text: response.bodyText,
                duration: 2000,
              });
            });
          }).catch(() => {});
        }
      });
    },
    closeRefundMethodModal() {
      this.$refs.editRefundMethod.hide();
      this.refund_method = { email: '', code: '' };
      this.$validator.reset();
    },
    canAddBankData() {
      if (this.complaint.refund_method === 'devolution_tbk' || this.complaint.refund_method === 'devolution_oneclick') { return false; }

      return true;
    },
    canUpdateRefundMethod() {
      if (store.state.user.role !== 3) { return false; }
      return ['approved_bank', 'approved_reimbursement', 'reimbursement_error'].includes(this.complaint.aasm_state) &&
              this.complaint.refund_method === 'payroll_bank' && ['WebPay', 'Fintoc'].includes(this.complaint.ticket_info.payment_method);
    },
    refreshReloaAppStatus() {
      this.intervalId = setInterval(() => {
        kexaApi.reloadAppStatus().then((response) => {
          if (response.body) {
            this.showDialog = true;
          }
        });
      }, 900000);
    },
    openFileModal(additionalInfoId) {
      kexaApi.getSignedLink(this.$route.params.complaint_id, additionalInfoId).then((data) => {
        this.signedLink = data.body.signed_link;
        this.$refs[`imageModal-${additionalInfoId}`][0].show();
      }).catch((response) => {
        this.$notify({
          group: 'show_complaint',
          type: 'error',
          title: 'Error',
          text: response.bodyText,
          duration: 2000,
        });
      });
    },
    openFileTab(additionalInfoId) {
      kexaApi.getSignedLink(this.$route.params.complaint_id, additionalInfoId).then((data) => {
        window.open(data.body.signed_link, '_blank');
      }).catch((response) => {
        this.$notify({
          group: 'show_complaint',
          type: 'error',
          title: 'Error',
          text: response.bodyText,
          duration: 2000,
        });
      });
    },
    dowloadFile(additionalInfoId) {
      kexaApi.getSignedLink(this.$route.params.complaint_id, additionalInfoId).then((data) => {
        const link = document.createElement('a');
        link.href = data.body.signed_link;
        link.download = '';
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }).catch((response) => {
        this.$notify({
          group: 'show_complaint',
          type: 'error',
          title: 'Error',
          text: response.bodyText,
          duration: 2000,
        });
      });
    },
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
};
</script>

<style lang="scss">
@import '../../assets/css/kexa-variables';

.selectize-input {
  min-width: 350px;
}

blockquote {
  background: {
    color: rgba(0, 0, 0, .15);
  }

  max-height: 260px;

  font: {
    size: 14px;
  }

  overflow: scroll;

  padding: {
    left: 12px;
    top: 10px;
    right: 10px;
    bottom: 10px;
  }

  font: {
    style: italic;
  }
}

pre {
  white-space: pre-wrap;
}

.fa-icon {
  position: relative;
  bottom: -2px;
}

.has-error {
  color: red;
}

[name="complaint[status]"]+.selectize-control {
  .selectize-dropdown-content {
    [data-value="open"] {
      background-color: $complaint-gray-open;
    }

    [data-value="pending_info"],
    [data-value="pending_requested"],
    [data-value="approved_communication"],
    [data-value="approved_bank"],
    [data-value="rejected_communication"] {
      background-color: $complaint-orange-crm;
    }

    [data-value="pending_err"] {
      background-color: $complaint-blue-err;
    }

    [data-value="pending_edb"] {
      background-color: $complaint-purple-bc;
    }

    [data-value="rejected"] {
      background: {
        color: $complaint-red-bc;
      }
    }

    [data-value="approved_reimbursement"],
    [data-value="closed"] {
      background: {
        color: $complaint-green-fin;
      }
    }
  }
}

.complaint-main-meta {
  color: #777777;

  font: {
    size: 90%;
  }
}

.complaint-meta-value {
  font: {
    weight: bold;
  }
}

.meta-info-title {
  min-width: 120px;
  display: block;
  float: left;
}

.complaint-summary-meta {
  padding: 0;
  float: left;
  width: 100%;

  li {
    display: block;

    padding: {
      left: 0;
      top: 4px;
      bottom: 4px;
    }
  }
}

.custom-file {
  cursor: pointer;

  &+.row {
    padding: {
      top: 10px;
    }

    justify-content: center;
  }
}

.btn-back {
  position: absolute;
  right: 22px;
  top: 10px;
  z-index: 1;
}

.loading-section {
  margin: 0 auto;
  display: block;
  color: #777777;
}

audio {
  width: 100%;
}

.zendesk-ticket-link {
  color: #212529;
  text-decoration: underline;
}

.related-zendesk {
  margin: {
    top: 30px;
  }
}

.svg-circle {
  width: 12px;
}

.list-group-item {
  button {
    color: #007bff;
    background: none;
    border: 0;
    padding: 0;
    outline: 0;

    &:hover,
    &:focus,
    &:active {
      color: #007bff;
      background: transparent;
      box-shadow: none;
    }
  }
}

.attachment_content {
  float: left;
  width: 90%;
}

.attachment_actions {
  float: right;
  width: 10%;
}

[id^="imageModal-"] {
  img {
    max-width: 100%;
  }
}

.edit-attribute {
  display: none;

  &.edit-visible {
    display: block;
  }

  .selectize-control.single {
    &+.btn-outline-success {
      top: -14px;
    }
  }

  .form-control {
    max-width: 300px;

    &+.btn-outline-success {
      top: -2px;
    }
  }

  .selectize-control.single,
  .form-control {
    margin-left: 120px;
    display: inline-block;
  }

  .selectize-control.single {
    .selectize-input {
      padding: {
        top: 8px;
        left: 12px;
        right: 40px;
        bottom: 8px;
      }
    }
  }

  .btn-outline-success {
    position: relative;
  }
}

.edit-icon-container {
  margin: {
    left: 6px;
  }

  .fa-icon {
    cursor: pointer;
    transition: .4s;

    &.active-edit {
      transform: rotate(180deg);
    }
  }
}

.bank-btns {
  margin-bottom: 5px;
}

.selectable {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/complaints/ShowComplaint.vue